// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"d85df937","311":"49c21803","615":"76b752b7","644":"d89122fd"}[chunkId] + ".chunk.js";
};